import { HomeWorkOutlined } from '@material-ui/icons';
import {
  Grid,
  Accordion,
  AccordionSummary,
} from '@material-ui/core';
import { observer } from 'mobx-react';
import { formatCurrency, getCompletePropertyAddress } from '@roc/ui/utils';
import { RoundedBackgroundIcon } from '../common/roundedBackgroundIcon';
import { ItemDisplay } from '../fixFlip/itemDisplay';
import { RentalPortfolioInformationFormStore } from '../../stores/rentalPortfolio/rentalPortfolioInformationFormStore';


interface PropertyInformationAccordionProps {
  store: RentalPortfolioInformationFormStore;
  expanded: boolean;
  onExpand: (expanded: boolean) => void;
  propertyTypes: string;
}

export const PortfolioInformationAccordion = observer(
  ({
    store,
    expanded,
    onExpand,
    propertyTypes,
  }: PropertyInformationAccordionProps) => {
    const property = store.getFormValues();

    let completeAddress = getCompletePropertyAddress(property);
    if (
      completeAddress === '' ||
      completeAddress.replace(/,/g, '').trim() === ''
    ) {
      completeAddress = '-';
    }

    return (
      <Accordion
        expanded={expanded}
        onChange={(e, expanded) => onExpand(expanded)}
        elevation={0}
      >
        <AccordionSummary
          aria-controls={`portfolio-information-accordion`}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={5}>
              <Grid
                container
                spacing={2}
                justifyContent="flex-start"
                alignItems="center"
                style={{ flexWrap: 'nowrap' }}
              >
                <Grid item alignItems="center" style={{ height: '100%' }}>
                  <RoundedBackgroundIcon
                    Icon={HomeWorkOutlined}
                    iconColor="#6D6D6D"
                  />
                </Grid>
                <Grid item style={{ maxWidth: '100%' }}>
                  <ItemDisplay
                    label="Portfolio Properties"
                    value={property.propertyStates}
                    alignItems="flex-start"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={7}>
              <Grid
                container
                spacing={3}
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item>
                  <ItemDisplay label="Property Types"
                    value={propertyTypes}
                  />
                </Grid>
                <Grid item>
                  <ItemDisplay
                    label="No. of Properties"
                    value={store.totalNoOfProperties.toString()}
                  />
                </Grid>
                <Grid item>
                  <ItemDisplay
                    label="Estimated As-is Value"
                    value={formatCurrency(store.totalEstimatedAsIsValue)}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </AccordionSummary>
      </Accordion>
    );
  }
);
